import Validatable from '@/validator/Validatable';

import {
  HeaderBidderSettingsStep,
  IHeaderBidderSettingsStep,
  IHeaderBidderSettingsStepAPI,
} from './HeaderBidderSettingStep';

interface IHeaderBidderConfigSchemaAPI {
  steps: IHeaderBidderSettingsStepAPI[];
  default_final_step_strategy: 'highest_cpm';
}

interface IHeaderBidderSettingsAPI {
  active: boolean;
  config_schema: IHeaderBidderConfigSchemaAPI;
  name: string;
  organization_complex_auctions_config_id: number;
  organization_id: number;
  schema_version: 1;
}

interface IHeaderBidderSettings {
  id: number;
  active: boolean;
  steps: IHeaderBidderSettingsStep[];
  name: string;
  organizationId: number;
  defaultFinalStepStrategy: 'highest_cpm';
}

export default class HeaderBidderSettings extends Validatable implements IHeaderBidderSettings {
  constructor(
    public active: boolean,
    public steps: HeaderBidderSettingsStep[],
    public name: string,
    public id = -1,
    public organizationId = -1,
    public defaultFinalStepStrategy: 'highest_cpm' = 'highest_cpm',
  ) {
    super();
  }

  static fromApi(auctionConfig: IHeaderBidderSettingsAPI): HeaderBidderSettings {
    return new HeaderBidderSettings(
      auctionConfig.active,
      auctionConfig.config_schema.steps.map((step) => HeaderBidderSettingsStep.fromApi(step)),
      auctionConfig.name,
      auctionConfig.organization_complex_auctions_config_id,
      auctionConfig.organization_id,
      auctionConfig.config_schema.default_final_step_strategy,
    );
  }

  toApi(): IHeaderBidderSettingsAPI {
    return {
      active: this.active,
      config_schema: {
        steps: this.steps.map((step) => step.toApi()),
        default_final_step_strategy: this.defaultFinalStepStrategy,
      },
      name: this.name,
      organization_complex_auctions_config_id: this.id,
      organization_id: this.organizationId,
      schema_version: 1, // Can only be 1 at the moment
    };
  }

  copy(): HeaderBidderSettings {
    return new HeaderBidderSettings(
      this.active,
      this.steps.map((step) => step.copy()),
      this.name,
      this.id,
      this.organizationId,
      this.defaultFinalStepStrategy,
    );
  }

  // TODO  - Add some relevant rules here
  static validatorCreateRules() {
    return {};
  }

  static parse(settings: IHeaderBidderSettings): HeaderBidderSettings {
    return new HeaderBidderSettings(
      settings.active ?? true,
      settings.steps.map((step) => HeaderBidderSettingsStep.parse(step)),
      settings.name ?? 'header_bidder_settings',
      settings.id || -1,
      settings.organizationId,
      'highest_cpm',
    );
  }
}
